import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getTenantScope } from "@/lib/api";

// Hide back button on the primary landing routes
const ROOT_ROUTES = new Set(["/", "/dashboard"]);

export default function BackButton() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const scope = getTenantScope();

  // For clients, hide on their own portal root
  const clientRoot = scope?.role === "client" ? `/clients/${scope.slug}` : null;
  if (ROOT_ROUTES.has(pathname)) return null;
  if (clientRoot && pathname === clientRoot) return null;

  const goBack = () => {
    if (window.history.length > 1) nav(-1);
    else if (scope?.role === "client") nav(`/clients/${scope.slug}`);
    else nav("/dashboard");
  };

  return (
    <div className="px-4 sm:px-6 pt-4">
      <Button
        data-testid="back-button"
        variant="ghost"
        size="sm"
        onClick={goBack}
        className="h-8 gap-2 text-slate-600 hover:text-indigo-700 hover:bg-indigo-50/70 dark:text-slate-300 dark:hover:bg-white/5 -ml-2"
      >
        <ArrowLeft className="h-4 w-4" />
        Back
      </Button>
    </div>
  );
}
